/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type StorefrontHome_storefrontData = {
    readonly edges: ReadonlyArray<{
        readonly node: {
            readonly serviceId: string | null;
        } | null;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"StorefrontFeaturedSection_products" | "StorefrontCreatorsUrls_featuredCreatorsUrls">;
    readonly " $refType": "StorefrontHome_storefrontData";
};
export type StorefrontHome_storefrontData$data = StorefrontHome_storefrontData;
export type StorefrontHome_storefrontData$key = {
    readonly " $data"?: StorefrontHome_storefrontData$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"StorefrontHome_storefrontData">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StorefrontHome_storefrontData",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "DealerStorefrontQueryEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Item",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "serviceId",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StorefrontFeaturedSection_products"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StorefrontCreatorsUrls_featuredCreatorsUrls"
    }
  ],
  "type": "DealerStorefrontQueryConnection",
  "abstractKey": null
};
(node as any).hash = 'a56ef9d086aa326c8205cd08bd497ba1';
export default node;
